<template>
  <div class="not-found-view">
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 10V23.18L37.42 18.58C36.64 17.8 35.36 17.8 34.58 18.58L28 25.18L21.42 18.6C20.64 17.82 19.38 17.82 18.6 18.6L12 25.18L6 19.16V10C6 7.8 7.8 6 10 6H38C40.2 6 42 7.8 42 10ZM36 22.84L42 28.86V38C42 40.2 40.2 42 38 42H10C7.8 42 6 40.2 6 38V24.84L10.58 29.42C11.36 30.2 12.62 30.2 13.4 29.42L20 22.82L26.58 29.4C27.36 30.18 28.62 30.18 29.4 29.4L36 22.84Z"
        fill="#ADADAD"
      />
    </svg>

    <AmTypography
      :text="$t('404NotFound.title')"
      textColor="text60"
      :typographyStyle="mq.current !== 'desktop' ? 'l0' : 'extraSize'"
    />

    <AmTypography
      id="not-found-message"
      :text="$t('404NotFound.description')"
      textColor="text60"
      :typographyStyle="mq.current !== 'desktop' ? 'l5' : 'l1'"
    />
  </div>
</template>

<script setup>
import { AmTypography } from '@appmax_npm/ds-appmax-v3'
import { inject } from 'vue'

const mq = inject('mq')
</script>

<style lang="scss" scoped>
.not-found-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 70vh;
    padding: 0 30px;
    margin-top: 80px;
}
</style>
